import { render } from "./NewMixModal.vue?vue&type=template&id=54c601c1&ts=true"
import script from "./NewMixModal.vue?vue&type=script&lang=ts"
export * from "./NewMixModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__